export default class SearchSpecOutsRequest {
    status = 10;
    ownerId: string;
    branchId: string;
}
